document.addEventListener('DOMContentLoaded', function () {
    var wipeAnimationswap = new TimelineMax();
    var GD88swapcontroller = new ScrollMagic.Controller();
    wipeAnimationswap.add([
        TweenMax.to('#slideContainerswap>section:nth-child(1)', 1, { className: '+=trunonleft1', delay: 1 }),
        TweenMax.to('#GD-88-swap-Container > div.progress-swap-container.page-width > p > span:nth-child(1)', 1, {
            className: '+=span_hide',
            delay: 1,
        }),
        TweenMax.to('#GD-88-swap-Container > div.progress-swap-container.page-width > p > span:nth-child(2)', 1, {
            className: '+=span_show',
            delay: 1,
        }),
        TweenMax.to('#slideContainerswap>section:nth-child(2)', 1, { className: '+=trunonleft2', delay: 1 }),
    ]);

    if ($(window).width() > 1000) {
        new ScrollMagic.Scene({
            triggerElement: '#GD-88-swap-Container',
            triggerHook: 'onLeave',
            duration: '100%',
        })
            .setPin('#GD-88-swap-Container')
            .setTween(wipeAnimationswap)
            .addTo(GD88swapcontroller);
    }
});